/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable radix */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import HelpIcon from '@material-ui/icons/Help';
import { Tooltip, IconButton } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import PATH from 'routes/path';

import { getAddress } from 'services/api/cep';
import Select from 'components/Select';
import { Title } from 'components/Text';
import { Button } from 'components/Button';
import { LabelInput } from 'components/Input';
import { ALERT_TYPE } from 'components/Alert';
import { LabelInputMask } from 'components/InputMask';
import { getStates, getCilvilStates } from 'components/Select/enums';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';
import Loading from 'components/Loading';
import { createEventTracking } from 'services/api/tracking';
import * as Sentry from '@sentry/react';
import {
  getCustomers,
  updateCustomer,
} from 'services/api/customers';

import { AuthContext } from 'providers/AuthProvider';
import HelpModal from './HelpModal';
import {
  Wrapper, Header, ButtonWrapper, InputWrapper, BoxOptin,
} from './styles';

const initValues = {
  full_name: '',
  email: '',
  phone: '',
  cpf: '',
  marital_status: '',
  profession: '',
  zip_code: '',
  street: '',
  number: '',
  extra: '',
  district: '',
  city: '',
  state: '',
};

// Dados pessoais
const UserData = () => {
  const [error, setError] = useState({});
  const [addressDisabled, setAddressDisabled] = useState({
    street: true,
    district: true,
    city: true,
    state: true,
  });
  const [user, setUser] = useState(initValues);
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [openHelp, setOpenHelp] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({ ...user, [name]: value });

    if (name === 'zip_code') {
      setError({ ...error, zip_code: '' });
      setLoading(false);
    }

    if (name === 'cpf') {
      setError({ ...error, cpf: '' });
      setLoading(false);
    }
  };

  const goBack = () => history.push(PATH.HOME);

  const showHelp = () => {
    window.Intercom('trackEvent', 'LOIT FGTS dados pessoais ajuda');
    setOpenHelp(true);
  };

  const closeHelp = () => setOpenHelp(false);

  // Carrega os dados do usuário (customer)
  const loadCustomer = async () => {
    try {
      const { data } = await getCustomers();

      setUser(data[0]);
    } catch (error) {
      const { response } = error;
      if (response.status === 403) {
        setTimeout(() => {
          loadCustomer();
        }, 4000);
      } else {
        Sentry.captureException(new Error('failed to get user data'));
        enqueueSnackbar('Erro ao carregar os dados do usuário.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    } finally {
      setLoadingData(false);
    }
  };

  // Atualiza os dados do usuário (customer)
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    let payload;
    if (user.meta_data && Object.keys(user.meta_data).length) {
      payload = {
        ...user,
        meta_data: {
          ...user.meta_data,
          step: user.meta_data.step && user.meta_data.step > 2 ? user.meta_data.step : 2,
        },
      };
    } else {
      payload = {
        ...user,
        meta_data: {
          step: 2,
        },
      };
    }

    if (error.zip_code) {
      enqueueSnackbar('Por favor, corrija os campos que estão inválidos.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
      return null;
    }

    try {
      await updateCustomer(user.id, payload);
      window.Intercom('update', {
        name: user.full_name && user.full_name,
        email: user.email && user.email,
        phone: currentUser.phoneNumber && currentUser.phoneNumber,
      });
      await createEventTracking('70 - dados pessoais completos');
      // TODO: REDIRECT TO HOME WITH SUCCESS MESSAGE
      history.push({
        pathname: PATH.PAYMENT,
        state: {
          idCase: user.meta_data.idCase,
        },
      });
    } catch (error) {
      const { response } = error;
      Sentry.captureException(new Error('failed to update user data'));
      if (response && response.data) {
        setError(response.data);
      }
    } finally {
      setLoading(false);
    }
  };

  // carrega os dados de endereço
  const loadAddress = async () => {
    try {
      const { data } = await getAddress(user.zip_code);
      if (data.erro) {
        const newErrors = { ...error, zip_code: 'CEP inválido.' };
        setError(newErrors);
        setUser({
          ...user,
          street: '',
          number: '',
          extra: '',
          district: '',
          city: '',
          state: '',
        });
        setAddressDisabled({
          street: true,
          district: true,
          city: true,
          state: true,
        });
      } else {
        setAddressDisabled({
          ...addressDisabled,
          street: !!data.logradouro,
          district: !!data.bairro,
          city: !!data.localidade,
          state: !!data.uf,
        });
        const newData = {
          ...user,
          state: data.uf,
          city: data.localidade,
          street: data.logradouro,
          district: data.bairro,
        };
        setUser(newData);
      }
    } catch (error) {
      Sentry.captureException(new Error('failed to fetch address'), (scope) => {
        scope.clear();
        scope.setContext('payload', {
          zip_code: user.zip_code,
        });
        return scope;
      });
      setError({
        ...error,
        zip_code: 'CEP inválido.',
      });
    }
  };

  useEffect(() => {
    document.title = 'Dados pessoais - Revisão FGTS - LOIT';

    window.Intercom('trackEvent', 'LOIT FGTS dados pessoais');

    loadCustomer();
    createEventTracking('60 - dados pessoais');
  }, []);

  if (loadingData) return <Loading bg="none" height="100%" />;

  return (
    <Wrapper>
      <Header>
        <Title secondary>Dados pessoais</Title>
        {/* ICONE DE AJUDA */}
        <Tooltip title="Informação sobre dados requisitados" arrow>
          <IconButton
            size="small"
            color="secondary"
            onClick={showHelp}
            disabled={openHelp}
          >
            Ajuda
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </Header>
      {/* MODAL DE AJUDA */}
      {
        openHelp && (
          <HelpModal
            open={openHelp}
            onClose={closeHelp}
          />
        )
      }
      {/* FORMULÁRIO */}
      <form onSubmit={handleSubmit}>
        {/* Nome */}
        <LabelInput
          required
          autoFocus
          type="text"
          name="full_name"
          autoComplete="name"
          label="Nome completo"
          value={user.full_name}
          onChange={handleChange}
          error={error.full_name}
        />
        {/* E-mail */}
        <LabelInput
          required
          type="email"
          name="email"
          value={user.email}
          onChange={handleChange}
          label="E-mail"
          autoComplete="email"
          error={error.email}
        />
        {/* Celular */}
        <LabelInputMask
          required
          type="tel"
          name="phone"
          mask="+55 (99) 9 9999-9999"
          value={user.phone}
          onChange={handleChange}
          label="Celular"
        />
        {/* CPF */}
        <LabelInputMask
          required
          type="text"
          label="CPF"
          name="cpf"
          value={user.cpf}
          onChange={handleChange}
          mask="999.999.999-99"
          error={error.cpf}
          helperText={error.cpf}
          style={{ width: '49%', marginRight: '2%' }}
        />
        {/* Estado cívil */}
        <Select
          required
          name="marital_status"
          label="Estado civil *"
          value={user.marital_status}
          onChange={handleChange}
          options={getCilvilStates()}
          error={error.marital_status}
        />
        {/* Profissão */}
        <LabelInput
          required
          type="text"
          name="profession"
          value={user.profession}
          onChange={handleChange}
          label="Profissão"
          error={error.profession}
        />
        {/* CEP */}
        <InputWrapper>
          <LabelInputMask
            required
            type="text"
            label="CEP"
            name="zip_code"
            value={user.zip_code}
            onChange={handleChange}
            mask="99999-999"
            onBlur={loadAddress}
            error={error.zip_code}
            helperText={error.zip_code}
            autoComplete="shipping postal-code"
          />
          <a
            target="_blank"
            rel="noreferrer"
            href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
          >
            Não sabe o CEP?
          </a>
        </InputWrapper>
        {/* Endereço */}
        <LabelInput
          required
          type="text"
          label="Endereço"
          name="street"
          value={user.street}
          onChange={handleChange}
          error={error.street}
          autoComplete="shipping street-address"
          disabled={addressDisabled.street}
        />
        {/* Número */}
        <LabelInput
          required
          type="text"
          label="Nº"
          name="number"
          value={user.number}
          onChange={handleChange}
          error={error.number}
          style={{ width: '30%', marginRight: '2%' }}
        />
        {/* Complemento */}
        <LabelInput
          type="text"
          name="extra"
          value={user.extra}
          onChange={handleChange}
          label="Complemento"
          style={{ width: '68%' }}
          error={error.extra}
        />
        {/* Bairro */}
        <LabelInput
          required
          type="text"
          label="Bairro"
          name="district"
          value={user.district}
          onChange={handleChange}
          style={{ width: '49%', marginRight: '2%' }}
          error={error.district}
          disabled={addressDisabled.district}
        />
        {/* Cidade */}
        <LabelInput
          required
          type="text"
          label="Cidade"
          name="city"
          value={user.city}
          onChange={handleChange}
          style={{ width: '49%' }}
          error={error.city}
          autoComplete="shipping address-level2"
          disabled={addressDisabled.city}
        />
        {/* Estado */}
        <Select
          required
          name="state"
          label="Estado *"
          value={user.state}
          onChange={handleChange}
          options={getStates()}
          error={error.state}
          autoComplete="shipping address-level1"
          disabled={addressDisabled.state}
        />
        <BoxOptin>
          <Checkbox
            id="disc"
            size="small"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <label htmlFor="disc" style={{ cursor: 'pointer' }}>
            Concordo que os meus dados pessoais estão corretos e que
            {' '}
            <strong>NÃO</strong>
            {' '}
            será possível alterá-los após a compra do KIT.
          </label>
        </BoxOptin>
        <ButtonWrapper>
          <Button
            type="submit"
            loading={loading}
            disabled={!user.full_name
              || !user.email
              || !user.cpf
              || !user.marital_status
              || !user.profession
              || !user.zip_code
              || !user.street
              || !user.number
              || !user.district
              || !user.city
              || !user.state
              || !checked}
          >
            Continuar
          </Button>
          <Button
            onClick={goBack}
            variant="outlined"
            className="unset"
          >
            Voltar
          </Button>
        </ButtonWrapper>
      </form>
    </Wrapper>
  );
};

export default UserData;
